import React from 'react';

interface ErrorMessageProps {
    errorMessage: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ errorMessage }) => (
    <div className="text-red fs-14px">{errorMessage}</div>
);

export default ErrorMessage;